import { socialLinks } from "./social.config";

export const FooterData = {
  heading: "Looking for someone who likes getting to the bottom of things?",

  button: {
    text: "Get in touch",
    link: "/contact",
  },

  socialLinks,

  copyright: "Camille Onoda. All rights reserved.",
};